import axios from 'axios'
import { getBreadcrumbs } from './breadcrumbs'

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

// O SDK Web do OneSignal (registerAdmin -> OneSignal.login(), ver
// notificationService.js) falha internamente com bastante frequência quando
// o Web Push não está configurado/habilitado pro App ID no dashboard do
// OneSignal (App ID hoje compartilhado com o app mobile, que só usa push
// nativo) -- a falha acontece dentro da própria fila de operação assíncrona
// do SDK, então nosso código nunca tem uma promise pra capturar/ignorar
// antes dela virar unhandledrejection. Cada uma dessas inundava os Logs de
// Erro com dezenas de entradas idênticas, inúteis pra depurar bugs reais do
// painel -- filtra pelo nome de arquivo interno do SDK (estável entre
// versões, aparece com sourcemap resolvido mesmo em produção).
const ONESIGNAL_SDK_FILES = ['LoginManager.ts', 'SessionManager.ts', 'pageSdkInit.ts', 'OneSignal.ts']
export function isOneSignalSdkNoise(stack) {
  return typeof stack === 'string' && ONESIGNAL_SDK_FILES.some(f => stack.includes(f))
}

function getBearerToken() {
  try {
    const user = JSON.parse(localStorage.getItem('user') ?? 'null')
    return user?.bearer_token ?? null
  } catch {
    return null
  }
}

// Instância própria (não usa `api`) — nunca deve passar pelo interceptor de
// erro da API principal, senão uma falha ao reportar geraria um novo reporte.
export function reportClientError(payload) {
  const token = getBearerToken()
  axios
    .post(`${API_URL}/public/client-error`, { ...payload, breadcrumbs: getBreadcrumbs() }, {
      headers: {
        'x-app-name': 'painel-adm',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      timeout: 5000,
    })
    .catch(() => {
      // Nunca deixa o report de erro quebrar o app
    })
}
